export default __webpack_public_path__ + "static/media/s-11.bb91b0b5.svg";